module.exports = __webpack_public_path__ + "img/bg01.5fde3278.gif";